import { useState } from 'react';
import { ReactComponent as Star } from "../../assets/icons-redesign/ai-star.svg";
import AiSampleSize from './ai-sample-size';
import { Dialog } from 'primereact/dialog';
import { isQA } from 'src/helpers/env.helpers';

interface CriteriaCardProps {
  extSurveyId: string;
}

const SurveyResponderTrigger = ({ extSurveyId }: CriteriaCardProps) => {
  // const config = FirebaseService.getRemoteConfigJSON<SurveySampleSizes>('SAMPLE_SIZES');
  // console.log('config', config);
  let ai: number[] = [];
  if (isQA()) {
    ai = [0, 10, 50, 100, 200];
  } else {
    ai = [0, 100, 200, 500, 750, 1000];
  }


  const [isOpen, setIsOpen] = useState(false);

  const iconStroke = 'white';
  return (
    <div>
      <button
        className="bg-purple-500 text-white px-3 py-2 h-[40px] rounded-full relative z-50"
        onClick={() => setIsOpen(true)}
      >
        <div className='cursor-pointer flex items-center gap-1.5 text-sm md:text-base font-medium'>
          <Star stroke={iconStroke} />
          AI Panelists
        </div>
      </button>

      <Dialog
        visible={isOpen}
        onHide={() => setIsOpen(false)}
      >
        <div className="p-0 max-w-xs w-[330px]">
          <div className="px-4 pb-4">
            <AiSampleSize
              extSurveyId={extSurveyId}
              sampleSizes={ai}
              zeroDisabled={false}
              onSubmit={() => setIsOpen(false)}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default SurveyResponderTrigger;
